import { CURRENCY_CODE } from '@shared/utils'

// Shared labels for secondary-market figures, so every surface phrases a
// price vs valuation the same way ("8.9% below", "4.0% above").

const PERCENT = 100

/** Signed % of `price` vs `valuation` — negative is below (a discount). */
export const varianceVsValuation = (price: number, valuation: number): number =>
  valuation > 0 ? Math.round(((price - valuation) / valuation) * PERCENT * 10) / 10 : 0

/** "8.9% below" / "4.0% above" / "At valuation" / "-" without a valuation. */
export const formatVariance = (variancePct: number | null): string => {
  if (variancePct === null) return '-'
  if (variancePct === 0) return 'At valuation'
  return `${Math.abs(variancePct).toFixed(1)}% ${variancePct < 0 ? 'below' : 'above'}`
}

// Secondary-market token prices sit around AED 1, so they always show at least
// two decimals ("AED 1.00", not "AED 1") and keep sub-cent precision when set.
const tokenPriceFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
})

/** "AED 0.92" / "AED 1.00" */
export const formatMarketTokenPrice = (price: number): string =>
  `${CURRENCY_CODE} ${tokenPriceFormatter.format(price)}`

/** "AED 0.86 – AED 1.16" */
export const formatBand = (min: number, max: number): string =>
  `${formatMarketTokenPrice(min)} – ${formatMarketTokenPrice(max)}`

/** "AED 0.92 / token" */
export const formatPerToken = (price: number): string => `${formatMarketTokenPrice(price)} / token`

const amountFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/** Money with two decimals ("AED 4,788.60") — order and proceeds figures. */
export const formatAmount = (amount: number): string =>
  `${CURRENCY_CODE} ${amountFormatter.format(amount)}`
